module.exports = "<div class=\"col-sm-12 col-xs-12 no-padding\">\n  <div style=\"float:right\" class=\"btn\" (click)=\"onDiscard()\"><span class=\"glyphicon glyphicon-remove\"></span></div>\n</div>\n<mat-video class=\"col-sm-12 col-xs-12 no-padding videoContainer\" [fullscreen]=\"false\" [download]=\"true\" color=\"accent\"\n  [keyboard]=\"false\" spinner=\"hourglass\" [src]=\"videoUrl\"></mat-video>"


//////////////////
// WEBPACK FOOTER
// ./src/app/video-dialog/video-dialog.component.html
// module id = ./src/app/video-dialog/video-dialog.component.html
// module chunks = main